import { Component, Injector, Input, OnInit, inject as inject_1, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule, JkDialogEditComponent, } from 'jk-service';
import { qbeCompare, idNameItem } from '../../services/qbe.model';
import { OpenwinService } from '../../services/openwin.service';
import { Openwin } from '../../_entity_uty';

export interface SqlWhereCondition {
  id: string;
  type1: '參數' | '條件';
  label: string;
  fieldName: string;
  dataType: 'number' | 'string' | 'date';
  compare: string;
  value: any;
  description: string;
}

@Component({
  selector: 'app-sql-where',
  templateUrl: './sql-where.component.html',
  styleUrls: ['./sql-where.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, FormsModule, MaterialModule,]
})
export class SqlWhereComponent extends JkDialogEditComponent<OpenwinService, Openwin> implements OnInit {
  override dialogRef: MatDialogRef<SqlWhereComponent>;
  override data: any;
  matDialog = inject_1(MatDialog);


  displayedColumns: string[] = ['id', 'type1', 'label', 'fieldName', 'dataType', 'compare', 'value', 'description'];
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input()
  whereList: SqlWhereCondition[] = [];
  compareList: idNameItem[] = qbeCompare;
  dataTypeList = ['number', 'string', 'date'];
  typeList = ['參數', '條件'];

  constructor() {
    const inject = inject_1(Injector);
    const dialogRef = inject_1<MatDialogRef<SqlWhereComponent>>(MatDialogRef);
    const data = inject_1(MAT_DIALOG_DATA);

    super(inject, dialogRef, data);

    this.dialogRef = dialogRef;
    this.data = data;
  }

  ngOnInit(): void {
    if (this.data && this.data.obj.mapContent) {
      try {
        const parsed = JSON.parse(this.data.obj.mapContent);
        if (Array.isArray(parsed) && parsed.length > 0) {
          this.whereList = parsed;
        } else {
          this.initDefaultList();
        }
      } catch (e) {
        this.initDefaultList();
      }
    } else {
      this.initDefaultList();
    }
  }

  initDefaultList() {
    for (let i = 1; i <= 10; i++) {
      this.whereList.push({
        id: i.toString().padStart(2, '0'),
        type1: '條件',
        label: '',
        fieldName: '',
        dataType: 'string',
        compare: '=',
        value: '',
        description: ''
      });
    }
  }

  onConfirm(): void {
    // const validList = this.whereList.filter(x => x.fieldName && x.fieldName.trim() !== '');
    this.dialogRef.close(JSON.stringify(this.whereList));
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
